import { manufacturingPartNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsManufacturingPartNumber";
import { css } from "styled-components";

/*

**** EC-231 Product Details Page (PDP) ****

*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
manufacturingPartNumberStyles.labelText = {
    css: css`
        font-weight: normal;
        // EC-617 : Fixing css issues on PLP & PDP
        font-size: 16px;
        margin-right: 15px;
    `,
};

manufacturingPartNumberStyles.valueText = {
    css: css`
        font-weight: 500;
        // EC-617 : Fixing css issues on PLP & PDP
        font-size: 16px;
        margin-bottom: 5px;
    `,
};
/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS. */
